import React from 'react';
import slackGif from './statmuse_slack.gif';

const IndexPage = () => (
  <div>
    <h1
      style={{
        textAlign: 'center',
        marginBottom: '20px',
      }}
    >
      StatMuse on Slack
    </h1>
    <div className="container-columns">
      <div className="item">
        <p>
          We know you already have the{' '}
          <a href="https://itunes.apple.com/us/app/statmuse/id1234654160?mt=8">
            StatMuse iOS app
          </a>{' '}
          and use the <a href="https://www.statmuse.com">site</a> regularly. Now
          you can explore StatMuse with your favorite teams and players directly
          from Slack.
        </p>
        <p>
          Simply click the "Add to Slack" button below and ask the StatMuse bot
          who won last night! Ask sports questions about players and teams from
          the NBA, MLB, NFL &amp; PGA.
        </p>
      </div>
      <div className="item center">
        <a href="direct_install">
          <img
            alt="Add to Slack"
            height="40"
            width="139"
            src="https://platform.slack-edge.com/img/add_to_slack.png"
            srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
          />
        </a>
      </div>
      <div className="item center">
        <img
          src={slackGif}
          alt="StatMuse on Slack"
          style={{
            width: '100%',
            maxWidth: '494px',
          }}
        />
      </div>
    </div>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js